import React from 'react'

import { Textarea as ChakraTextarea } from '@chakra-ui/react'
import { Controller, useFormContext } from 'react-hook-form'
import FieldWrapper from './FieldWrapper/FieldWrapper'

const Textarea = ({ name, row = 5, disabled, requiredMessage = '', ...rest }) => {
  const { getValues } = useFormContext()

  const defaultValue = getValues(name)

  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={{ required: requiredMessage !== '' ? requiredMessage : false }}
      render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => {
        return (
          <FieldWrapper name={name} error={error} {...rest}>
            <ChakraTextarea
              ref={ref}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              rows={row}
              as="textarea"
              disabled={disabled}
              borderWidth={3}
              // whiteSpace={'pre-line'}
            />
          </FieldWrapper>
        )
      }}
    />
  )
}

export default Textarea
